import { SiteNav } from "@/components/site/SiteNav";
import { SiteFooter } from "@/components/site/SiteFooter";
import { PageMeta } from "@/components/site/PageMeta";

const SECTIONS = [
  {
    h: "General Disclaimer",
    p: "The content on DrSullySpeaks.com is provided for educational, inspirational, and informational purposes only. It is not, and should not be construed as, professional medical, mental-health, legal, financial, tax, or investment advice. Reading this site, subscribing to communications, or engaging with Dr. Sully’s programs does not create a clinician–patient, attorney–client, fiduciary, or any other professional relationship.",
  },
  {
    h: "Coaching vs. Therapy",
    p: "Executive coaching is a forward-focused, performance-oriented engagement. It is not a substitute for therapy, counseling, psychiatric care, or treatment of any mental-health condition. Dr. RD “Sully” Sullivan holds clinical and ministerial credentials, but coaching engagements with He Speaks Organic Coaching & Consulting LLC are explicitly non-clinical unless a separate clinical agreement is executed in writing.",
  },
  {
    h: "Faith-Informed, Not Denominational",
    p: "Dr. Sully’s work is faith-informed and openly Christ-centered. Participation in coaching, masterclasses, the MAKECHANGE Circle, or speaking engagements does not require a particular religious affiliation. Clients of all faiths and none are welcome.",
  },
  {
    h: "Results & Earnings Disclaimer",
    p: "Testimonials, case studies, and outcome examples reflect the experiences of specific individuals and organizations. They are not promises, guarantees, or projections of the results you will achieve. Your results will vary based on effort, market conditions, prior experience, team capacity, and many factors outside of Dr. Sully’s control. No representation is made that any client will or is likely to achieve similar results.",
  },
  {
    h: "AI Tools & Information",
    p: "Any AI strategy guidance, prompts, frameworks, or tools referenced on this site are provided as starting points. AI systems can produce inaccurate, biased, or fabricated output. You are responsible for validating any AI-generated content before deploying it, and for ensuring its use complies with applicable law, your organization’s policies, and the rights of third parties.",
  },
  {
    h: "Third-Party Links",
    p: "Outbound links to other websites, services, or vendors are provided for convenience. We do not endorse, control, or assume responsibility for the content, policies, or practices of any third-party site.",
  },
  {
    h: "Booking, Refunds & Cancellations",
    p: "Each engagement (coaching, masterclass, Circle membership, speaking, or consulting) is governed by the specific agreement or terms presented at checkout or contract signing. Those terms control over anything stated generally on this site. Where no separate agreement exists, digital products are non-refundable once delivered; live programs follow the cancellation policy stated at registration.",
  },
  {
    h: "Privacy",
    p: "We collect only what we need to deliver services and communications: name, email, organization, and the details you choose to share through inquiry and registration forms. Form data is stored in our secure backend and is never sold. You may request access, correction, or deletion of your information at any time by emailing the address listed on this site.",
  },
  {
    h: "Trademarks",
    p: "DrSullySpeaks™, MAKECHANGE™, and the MAKECHANGE Framework™ are trademarks of He Speaks Organic Coaching & Consulting LLC. All other marks are the property of their respective owners.",
  },
  {
    h: "Contact",
    p: "Questions about anything on this page? Email DrSully@DrSullySpeaks.com or call (855) 76-COACH. We reply within one business day.",
  },
];

const Legal = () => (
  <div className="min-h-screen bg-background text-foreground">
    <PageMeta
      title="Legal & Disclaimers — DrSullySpeaks"
      description="Disclaimers, results disclosure, coaching scope, AI guidance, privacy, and trademark notices for DrSullySpeaks and the MAKECHANGE Framework."
      path="/legal"
    />
    <SiteNav />

    <section className="pt-32 pb-20 md:pt-40 md:pb-28 border-b border-border">
      <div className="container max-w-3xl">
        <span className="eyebrow">Legal · Updated {new Date().getFullYear()}</span>
        <h1 className="font-display font-bold uppercase text-white text-4xl md:text-6xl mt-5 leading-[1.05]">
          Legal & <span className="text-gradient-gold">Disclaimers</span>
        </h1>
        <p className="text-silver text-base md:text-lg mt-6 leading-relaxed">
          Plain-English terms for working with Dr. Sully and engaging with this
          site. Specific program agreements always control over the general
          terms below.
        </p>
      </div>
    </section>

    <section className="py-20 md:py-28">
      <div className="container max-w-3xl space-y-12">
        {SECTIONS.map((s) => (
          <article key={s.h}>
            <h2 className="font-display uppercase text-white text-xl md:text-2xl tracking-wide">
              {s.h}
            </h2>
            <p className="text-silver text-sm md:text-base mt-3 leading-relaxed">{s.p}</p>
          </article>
        ))}
        <p className="text-[10px] uppercase tracking-[0.25em] text-silver/60 pt-8 border-t border-border">
          © {new Date().getFullYear()} He Speaks Organic Coaching & Consulting LLC. All rights reserved.
        </p>
      </div>
    </section>

    <SiteFooter />
  </div>
);

export default Legal;
